import { API_SERVER } from "utils/config";
// Factory, not a shared module singleton. Callers used to seed the
// old emptyCustomAnswerData array into form state by reference, so every
// row seeded from it shared one object across resets and mounts. Do not
// mutate the returned rows.
export const makeEmptyCustomAnswerData = () => [
    { text: "", nanoid: "", saved: false },
];

export const emptySurveyQuestionResponse = {
    text: "",
    position: 1,
};

export const RESPONSE_OPTION_MAX_LENGTH = 255;

export const emptySurveyQuestionData = {
    answer_type: "multiple",
    description: "",
    is_allow_custom: false,
    is_random_order: false,
    is_view_all: true,
    position: 1,
    question_type: "freeform",
    text: "",
    preset_answers: [],
    is_demographic_question: false,
    contains_pii: false,
    answer_limit: 150,
    media_url: ''
};

// Frontend implements defensive validation for user_limit: the backend value
// is only treated as valid if it is 1 or higher. Otherwise we fall back to
// MIN_SEAT_COUNT (1).
export const MIN_SEAT_COUNT = 1;

/**
 * Returns userLimit if valid (number >= 1), otherwise MIN_SEAT_COUNT.
 * @param {number|null|undefined} userLimit - The user_limit from backend
 * @returns {number} A valid user_limit (minimum 1)
 */
export const getValidUserLimit = (userLimit) => {
    if (typeof userLimit === 'number' && userLimit >= MIN_SEAT_COUNT) {
        return userLimit;
    }
    return MIN_SEAT_COUNT;
};

export const SUBSCRIPTION_NAMES = {
    FREE_INDIVIDUAL: "Free Plan (Individual)",
    // Canonical backend strings (sql/deploy/saas/update_stripe_products.sql);
    // used when the plan name is derived from the subscription endpoint
    // rather than a purchase row's description.
    MONTHLY: "Gobby Monthly Subscription",
    YEARLY: "Gobby Yearly Subscription",
};

// Managed accounts have no stripe_subscription row, so the organisation
// endpoint's subscription_name stays "Free Plan (Individual)" for them and the
// store-computed subscriptionDetails must win.
export const resolvePlanLabel = (isManaged, subscriptionDetails, orgSubscriptionName) => (
    (isManaged && subscriptionDetails) || orgSubscriptionName || subscriptionDetails || SUBSCRIPTION_NAMES.FREE_INDIVIDUAL
);

// Profile pictures live at a constant URL with no server cache headers
// or version field, so every consumer derives the URL from the store's
// pictureVersion (seeded per page load, bumped after each picture
// change) to bust both the in-session memory cache and the HTTP cache.
export const userPictureUrl = (userId, version) =>
    `${API_SERVER}/v2/user/${userId}/picture?v=${version}`;
